export var PACKAGE_SOURCE = "components";
export var PACKAGE_VERSION = "3.0.0 (414c6787)";
export var GIT_SHA = "414c6787";
export var THEME = "core";
export var SYSTEM = "core";
export var ALWAYS_VISUAL_REFRESH = true;
export var INCLUDE_ONE_THEME = false;